{
  "version": 1,
  "asset_id": "05ae04d4-7d13-45b0-a2c8-b5d93d7180bb",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/05ae04d4-7d13-45b0-a2c8-b5d93d7180bb/tools-hero.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/05ae04d4-7d13-45b0-a2c8-b5d93d7180bb/tools-hero.webp",
  "original_filename": "tools-hero.webp",
  "size": 120844,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:31:38Z"
}
